import React from 'react';

const courses = [
  {
    id: 1,
    title: 'AI Trading Foundations',
    progress: 75,
    status: 'In Progress',
  },
  {
    id: 2,
    title: 'Mastering RSI Divergence',
    progress: 100,
    status: 'Completed',
  },
  {
    id: 3,
    title: 'Market Maker Trap Zone Course',
    progress: 40,
    status: 'In Progress',
  },
];

export default function LearningProgressBox() {
  return (
    <div className="bg-black shadow rounded-lg p-4 mb-6">
      <h3 className="text-sm font-semibold text-gray-800 mb-3">🎓 Learning Progress</h3>
      <ul className="space-y-4 text-sm text-gray-700">
        {courses.map((course) => (
          <li key={course.id}>
            <div className="flex justify-between mb-1">
              <span className="font-semibold">{course.title}</span>
              <span className="text-xs text-gray-500">{course.status}</span>
            </div>
            <div className="w-full bg-gray-200 h-2 rounded">
              <div
                className={`h-2 rounded ${
                  course.progress === 100 ? 'bg-green-500' : 'bg-blue-500'
                }`}
                style={{ width: `${course.progress}%` }}
              ></div>
            </div>
            <p className="text-xs text-gray-500 mt-1">{course.progress}% complete</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
